﻿window.VoterFly = window.VoterFly || {};

require('./site.js');
require('./ui.js');
require('./file-picker.js'); // extends VoterFly.UI, so it must follow ui.js
require('./util.js');
require('./instrumentation.js');
require('./social.js');
require('./lazyloader.js');
require('./tag-helpers.js');
require('./stripe.js');